package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.screens.openQuestions.api.GoogleScriptApi
import com.eladfinish.bible.contest.screens.openQuestions.model.SheetNames

class GetGoogleScriptDataUseCase(
    private val googleScriptApi: GoogleScriptApi,
) {

    suspend operator fun invoke(id: String): Result<SheetNames?> =
        googleScriptApi.getSheetNames(id)

}
